
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup, AbstractControl, Form } from '@angular/forms';
import { RutValidator } from 'ng2-rut';

import { UserService } from '../../../services/user.service';

import { WizardComponent } from 'node_modules/angular-archwizard';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { validateRutFactory } from 'ng2-rut/dist/rut.validator';
import { rutClean } from 'rut-helpers';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css'],
  providers: [UserService, ClaveUnicaService]
})
export class RegistroComponent implements OnInit {
  @ViewChild('wizard') wizard: WizardComponent;
  public rutBuscar;
  public form;
  public user;
  public comunas;
  public regiones;
  public comunasFinal
  public btnclicked;
  public buscando = true;
  public registro = true;

  public userform;
  public identityData
  constructor(
    private _userService: UserService,
    private fb: FormBuilder,
    private rutValidator: RutValidator,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private store: Store<AppState>,
    private _router: Router,
    private snackBar: MatSnackBar,
    private claveUnicaService: ClaveUnicaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("DATA", data);

    this.userform = this.fb.group({
      busc_rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
    })


    this.form = new FormGroup({
      rut: new FormControl(['', [Validators.required, rutValidator, Validators.minLength(8)]]),
      nombres: new FormControl('', [Validators.required, Validators.minLength(3)]),
      apellidoP: new FormControl('', [Validators.required, Validators.minLength(3)]),
      apellidoM: new FormControl('', [Validators.required, Validators.minLength(3)]),
      profesion: new FormControl(''),
      calle: new FormControl('', [Validators.required, Validators.minLength(3)]),
      numero: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern(/[0-9]*/)]),
      complemento: new FormControl(''),
      telefono: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(9), Validators.pattern(/[0-9]*/)]),
      region: new FormControl('', [Validators.required, Validators.minLength(1)]),
      comuna: new FormControl('', [Validators.required, Validators.minLength(1)]),
      email: new FormControl('', [Validators.required, Validators.minLength(3), Validators.email]),
      passwords: this.fb.group({
        password: new FormControl('', [Validators.required, Validators.minLength(4)]),
        repassword: new FormControl('', [Validators.required, Validators.minLength(4)])
      },
        { validator: this.passwordConfirming }),
    })



  }

  ngOnInit() {
    this.resetearForm()
    this.getRegiones();
    this.getComunas();

    if (sessionStorage.getItem('identity-domCloud')) {
      this.identityData = this._userService.getIdentity();
      this.buscando = false
      console.log(this.identityData);

      this.form.controls['rut'].setValue(this.identityData.rut + this.identityData.dv);
      this.form.controls['nombres'].setValue(this.identityData.nombres);
      this.form.controls['apellidoP'].setValue(this.identityData.apellidoP);
      this.form.controls['apellidoM'].setValue(this.identityData.apellidoM);
      this.form.controls['nombres'].disable()
      this.form.controls['apellidoP'].disable()
      this.form.controls['apellidoM'].disable()
    }
  }

  passwordConfirming(c: AbstractControl): { mismatchedPasswords: boolean } {
    if (c.get('password').value !== c.get('repassword').value) {
      return { mismatchedPasswords: true };
    }
  }

  buscarUsuario() {
    this.spinner.show();

    this.form.patchValue({
      rut: this.userform.value.busc_rut
    })
    this._userService.buscarUsuario(rutClean(this.userform.value.busc_rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          alert("Su usuario ya existe")
        }
        if (response.register) {
          this.spinner.hide();
          this.buscando = false
          this.registro = true
        }
        if (response.update) {
          this.spinner.hide();
          this.buscando = false
          this.registro = false

          console.log(response.data);
          this.form.controls['nombres'].setValue(response.data.Sol_Nombres);
          this.form.controls['apellidoP'].setValue(response.data.Sol_Apel_Pat);
          this.form.controls['apellidoM'].setValue(response.data.Sol_Apel_Mat);
          this.form.controls['profesion'].setValue(response.data.Sol_Profesion);
          this.form.controls['calle'].setValue(response.data.Sol_Direc_Calle);
          this.form.controls['numero'].setValue(response.data.Sol_Direc_Num);
          this.form.controls['email'].setValue(response.data.Sol_Mail);
          this.form.controls['telefono'].setValue(response.data.Sol_Fono);
        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

  register() {
    if (this.registro) {
      if (this.form.valid) {
        this.spinner.show();
        this._userService.register(this.form).subscribe(
          response => {
            this.finishRegister()
            this.spinner.hide();
            this.resetearForm()
          },
          error => {
            let e = JSON.parse(error._body);
            this.spinner.hide();
          }
        )
      } else {
        this.btnclicked = true;
        swal({
          type: 'error',
          title: "Aviso",
          text: "El formulario no es válido, por lo tanto no se puede crear el usuario.",
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          window.scroll(0, 0);
        });
      }
    }



    if (!this.registro) {
      this.form.controls.passwords.controls['password'].setValue('1234');
      this.form.controls.passwords.controls['repassword'].setValue('1234');
      if (this.form.valid) {
        console.log("aca", this.form.valid);
        this.spinner.show();
        this._userService.register(this.form).subscribe(
          response => {
            this.finishRegister()
            this.spinner.hide();
            this.resetearForm()
          },
          error => {
            let e = JSON.parse(error._body);
            this.spinner.hide();
          }
        )

      } else {
        this.btnclicked = true;
        swal({
          type: 'error',
          title: "Aviso",
          text: "El formulario no es válido, por lo tanto no se puede actualizar el usuario.",
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          window.scroll(0, 0);
        });
      }
    }

  }

  getComunas() {
    this._userService.getComunas().subscribe(
      response => {
        console.log('getComunas response', response)
        this.comunas = response
      },
      error => {
        let e = JSON.parse(error._body);
      }
    )
  }

  getRegiones() {


    this._userService.getRegiones().subscribe(
      response => {
        console.log('getRegiones response', response)
        this.regiones = response
      },
      error => {
        let e = JSON.parse(error._body);
      }
    )
  }

  resetearForm() {
    this.form.controls['rut'].setValue('');
    this.form.controls['nombres'].setValue('');
    this.form.controls['apellidoP'].setValue('');
    this.form.controls['apellidoM'].setValue('');
    this.form.controls['profesion'].setValue('');
    this.form.controls['calle'].setValue('');
    this.form.controls['numero'].setValue('');
    this.form.controls['complemento'].setValue('');
    this.form.controls['telefono'].setValue('');
    this.form.controls['region'].setValue('');
    this.form.controls['comuna'].setValue('');
    this.form.controls['email'].setValue('');
    this.form.controls.passwords.controls['password'].setValue('');
    this.form.controls.passwords.controls['repassword'].setValue('');
  }

  cambiarComunas(region) {

    this.comunasFinal = [];
    let nRomanoRegion;
    let nRomanoComuna
    this.regiones.data.forEach(elemento => {
      //console.log('elemento', elemento)
      if (this.quitarTildes(elemento.fieldData.region) == this.quitarTildes(this.form.get('region').value)) {
        nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
      }
    })
    this.comunas.forEach(element => {
      nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas
      if (nRomanoRegion == nRomanoComuna) {
        this.comunasFinal.push(element)
      } else {
      }
    })
    if (this.comunasFinal.length == 0) { console.log(`campo region en tabla regiones ( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `) }
    console.log('this.comunasFinal', this.comunasFinal)

  }

  quitarTildes(palabra: string) {
    palabra = palabra.toLowerCase()
    return palabra.replace(/á/gi, "a").replace(/é/gi, "e").replace(/í/gi, "i").replace(/ó/gi, "o").replace(/ú/gi, "u").replace(/ñ/gi, "n");

  }

  finishRegister() {
    this.dialog.closeAll();
  }

  async logout() {
    this.dialog.closeAll();
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  back() {
    this._router.navigate(['/inicio'])
  }

}